export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/tropicoretreat',
  linkedin: 'https://www.linkedin.com/company/tropico-retreat',
} as const;
